import React, {Component} from "react";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';
import { AGE_BUCKETS } from '../servicePortal/agingBuckets.js';

const AGEING_OPTIONS = AGE_BUCKETS.map(bucket => ({value: bucket, label: bucket}));

class OpenTicketAgeingFilter extends Component {
    state = {
        ageingValue: AGEING_OPTIONS
    };

    resetAgeingFilter() {
        this.setState({
            ageingValue: AGEING_OPTIONS,
        })
    }

    changeAgeing(optionSelected) {
        let ageingArray = [];
        const selected = optionSelected === null ? [] : optionSelected;
        selected.map((option, i) => {
            ageingArray.push(option.value)
        });
        this.props.onSelectAgeing(selected, ageingArray);
        this.setState({
            ageingValue: selected,
        });
    }

    render() {

        return (
            <ReactMultiSelectCheckboxes name="ageing"
                isMulti
                value={this.state.ageingValue}
                styles={reactSelectStyles} className="report-listbox"
                isClearable={false}
                onChange={this.changeAgeing.bind(this)}
                options={AGEING_OPTIONS}
                placeholderButtonLabel="All"
            />
        );

    }
}
export default OpenTicketAgeingFilter;
